export default __webpack_public_path__ + "static/media/zawodnik2.4b9b5f8a.png";